module.exports = __webpack_public_path__ + "media/images/btn_cover_report-3b33b629f2f1c5758e1d42d1a55330e5.gif";